var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-date-selector"},[_c('button',{on:{"click":_vm.selectPrevious}},[_vm._v("<")]),_c('button',{on:{"click":_vm.selectCurrent}},[_vm._v("امروز")]),_c('button',{on:{"click":_vm.selectNext}},[_vm._v(">")])])}
var staticRenderFns = []

export { render, staticRenderFns }